import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import FlexboxGapStack from './FlexboxGapStack';
import ClientProvider from './client';
export default createDemo(import.meta.url, FlexboxGapStack, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/components/stack/demos/flexbox-gap/FlexboxGapStack.tsx",
    "fileName": "FlexboxGapStack.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Stack from '@mui/system/Stack';\nimport Box from '@mui/system/Box';\nimport { styled } from '@mui/system';\n\nconst Item = styled('div')(({ theme }) => ({\n  backgroundColor: '#fff',\n  padding: theme.spacing(1),\n  textAlign: 'center',\n  borderRadius: 4,\n  flexGrow: 1,\n  ...theme.applyStyles('dark', {\n    backgroundColor: '#262B32',\n  }),\n}));\n\nexport default function FlexboxGapStack() {\n  return (\n    <Box sx={{ width: 200 }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Stack\n        spacing={{ xs: 1, sm: 2 }}\n        direction=\"row\"\n        useFlexGap\n        sx={{ flexWrap: 'wrap' }}\n      >\n        <Item>Item 1</Item>\n        <Item>Item 2</Item>\n        <Item>Long content</Item>\n      </Stack>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 31,
        "focusedLines": 10,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Stack from '@mui/system/Stack';\nimport Box from '@mui/system/Box';\nimport { styled } from '@mui/system';\n\nconst Item = styled('div')(({ theme }) => ({\n  backgroundColor: '#fff',\n  padding: theme.spacing(1),\n  textAlign: 'center',\n  borderRadius: 4,\n  flexGrow: 1,\n  ...theme.applyStyles('dark', {\n    backgroundColor: '#262B32',\n  }),\n}));\n\nexport default function FlexboxGapStack() {\n  return (\n    <Box sx={{ width: 200 }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Stack\n        spacing={{ xs: 1, sm: 2 }}\n        direction=\"row\"\n        useFlexGap\n        sx={{ flexWrap: 'wrap' }}\n      >\n        <Item>Item 1</Item>\n        <Item>Item 2</Item>\n        <Item>Long content</Item>\n      </Stack>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 19
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Stack"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 20
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "spacing"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "xs"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "sm"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "2"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 21
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "direction"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "row",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 22
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "useFlexGap"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 23
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "flexWrap"
              ],
              ": ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "wrap",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 24
            },
            "      >"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 25
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">Item 1</",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 26
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">Item 2</",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 27
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">Long content</",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 28
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Stack"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 31,
    "focusedLines": 10,
    "collapsible": true,
    "externals": [
      "@mui/system/Stack",
      "@mui/system/Box",
      "@mui/system"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
